import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Video, Users } from "lucide-react";
import { GoogleOAuthButton } from "@/components/GoogleOAuthButton";
import AssignedVideos from "./AssignedVideos";
import InterviewerManagement from "./InterviewerManagement";

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('videos');

  return (
    <>
      <div className="min-h-screen bg-background">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-foreground mb-4">
              Admin Dashboard
            </h1>
            <p className="text-xl text-muted-foreground">
              Manage videos, interviewers, and system operations
            </p>
          </div>

          {/* Google OAuth Integration */}
          <div className="mb-12">
            <div className="bg-secondary border border-secondary-border rounded-lg p-8">
              <h2 className="text-2xl font-semibold text-foreground mb-6">
                Google Integration
              </h2>
              <GoogleOAuthButton />
            </div>
          </div>

          {/* Tab Navigation */}
          <div className="mb-6">
            <div className="flex space-x-1 bg-secondary border border-secondary-border rounded-lg p-1">
              <button
                onClick={() => setActiveTab('videos')}
                className={`flex items-center px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  activeTab === 'videos'
                    ? 'bg-primary text-white shadow-sm'
                    : 'text-muted-foreground hover:text-foreground hover:bg-secondary/50'
                }`}
              >
                <Video className="h-4 w-4 mr-2" />
                Assigned Videos
              </button>
              <button
                onClick={() => setActiveTab('interviewers')}
                className={`flex items-center px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  activeTab === 'interviewers'
                    ? 'bg-primary text-white shadow-sm'
                    : 'text-muted-foreground hover:text-foreground hover:bg-secondary/50'
                }`}
              >
                <Users className="h-4 w-4 mr-2" />
                Interviewers
              </button>
            </div>
          </div>

          {/* Tab Content */}
          {activeTab === 'videos' && (
            <div className="bg-secondary border border-secondary-border rounded-xl p-6">
              <AssignedVideos />
            </div>
          )}

          {activeTab === 'interviewers' && (
            <InterviewerManagement />
          )}
        </div>
      </div>
    </>
  );
} 